import { NgModule } from '@angular/core';
import { Routes, RouterModule } from "@angular/router";
import { ScheduleListComponent } from './schedule-list/schedule-list.component';
import { ScheduleDefintionComponent } from './schedule-definition/schedule-definition.component';
import { ChangeControlComponent } from './change-control/change-control.component';
import { StandardDrawingComponent } from './standard-drawing/standard-drawing.component';


export const engineeringScheduleRoutes: Routes = [
    { path: 'scheduledefinition', component: ScheduleDefintionComponent, data: { title: 'SCHEDULE DEFINITION', isProjectCodeRequired: true } },
    { path: 'schedulelist', component: ScheduleListComponent, data: { title: 'SCHEDULE DOCUMENTS', isProjectCodeRequired: true } },
    { path: 'changecontrol', component: ChangeControlComponent, data: { title: 'CHANGE CONTROL NOTE', isProjectCodeRequired: true } },
    { path: 'standard-drawing', component: StandardDrawingComponent, data: { title: 'STANDARD DRAWING', isProjectCodeRequired: true } },
];

@NgModule({
    imports: [RouterModule.forChild(engineeringScheduleRoutes)],
    exports: [RouterModule]
})

export class EngineeringScheduleRoutingModule {
}
